module.exports = __webpack_public_path__ + "25ad69845c40ea98f84a587fcce12e21.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/suppliers/sales2.png
// module id = 544
// module chunks = 21 77 88